import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { plusIcon } from "../../helpers/iconHelpers";
import CustomButton from "../../CustomButton";
import NoZonesHeader from "./NoZonesHeader";

export default function NoZonesComponent (props) {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'zonesPage' });

    const setMode = useCallback((payload) => {
        dispatch({ type: 'SET_MODE', payload })
    }, [dispatch]);

    const createNewZone = () => {
        setMode('CREATE');
    }

    return (
        <div className="no-zones-container">
            <div className="no-zones-info-box">
                <NoZonesHeader />
                <CustomButton
                    variant='primary'
                    prefix="flex-btn add-new-zone-btn"
                    onClick={createNewZone}
                >
                    {plusIcon}
                    {t('createNewZone')}
                </CustomButton>
            </div>
        </div>
    )
}
